import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { faqTabs } from "../../mock";

export default function Faq() {
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(0);
  const items = faqTabs[tab].items;

  return (
    <section id="faq" className="bg-lybl-paper py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow>FAQs</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink text-balance">Have questions? We're here to help.</h2></Reveal>
        </div>

        <Reveal delay={120}>
          <div className="mt-10 flex flex-wrap justify-center gap-2">
            {faqTabs.map((t, i) => (
              <button key={t.tab} onClick={() => { setTab(i); setOpen(0); }} className={`rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${tab === i ? "bg-lybl-green text-white" : "bg-white text-lybl-ink/70 ring-1 ring-black/5 hover:bg-lybl-cream"}`}>
                {t.tab}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 space-y-3">
          {items.map((it, i) => (
            <div key={it.q} className="rounded-2xl bg-white ring-1 ring-black/5 overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                <span className="font-serif text-lg text-lybl-ink">{it.q}</span>
                <span className="h-8 w-8 shrink-0 rounded-full bg-lybl-cream flex items-center justify-center text-lybl-green">
                  {open === i ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                </span>
              </button>
              <div className="grid transition-all duration-300" style={{ gridTemplateRows: open === i ? "1fr" : "0fr" }}>
                <div className="overflow-hidden">
                  <p className="px-6 pb-5 text-[15px] text-lybl-muted leading-relaxed">{it.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
